import React, { Fragment, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ErrorPage from "../ErrorPage/ErrorPage";
import { getProduct } from "../../data/products";

const ProductShowcase: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const product = getProduct(slug || "");

  useEffect(() => {
    if (product) document.title = `${product.name} — KOT Enterprises`;
  }, [product]);

  if (!product) return <ErrorPage />;

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={product.name} pagesub="Our Work" />

            {/* ===== Hero: intro (content only) ===== */}
            <section className="about pt-100 pb-40">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="sec-title mb-0">
                      <span className="sub-title mb-10">{product.tagline}</span>
                      <h2 className="title title-line_height">{product.name}</h2>
                      <p className="content mt-20">{product.summary}</p>
                    </div>
                    <ul className="xb-prod-meta">
                      <li>
                        <span>Industry</span>
                        {product.industry}
                      </li>
                      <li>
                        <span>Platform</span>
                        {product.platform}
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Highlights */}
                <div className="row mt-none-30 mt-40 justify-content-center">
                  {product.highlights.map((h, i) => (
                    <div className="col-lg-3 col-md-6 mt-30" key={i}>
                      <div className="xb-prod-stat xb-border">
                        <span className="xb-prod-stat--value">{h.value}</span>
                        <span className="xb-prod-stat--label">{h.label}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* ===== Overview ===== */}
            <section className="about pb-40">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="xb-prod-overview xb-border">
                      {product.overview.map((p, i) => (
                        <p key={i}>{p}</p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ===== How it works + sections ===== */}
            <section className="about pb-80">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    {product.sections.map((sec, i) => (
                      <div className="xb-prod-sec" key={i}>
                        <h3 className="xb-prod-sec--title">{sec.title}</h3>
                        {sec.paragraphs?.map((p, j) => (
                          <p className="xb-prod-sec--para" key={j}>
                            {p}
                          </p>
                        ))}
                        {sec.bullets && (
                          <ul className="xb-prod-sec--list">
                            {sec.bullets.map((b, j) => (
                              <li key={j}>{b}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* ===== CTA ===== */}
            <section className="contact-section pb-120">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-10">
                    <div className="xb-contact-form xb-border text-center">
                      <div className="sec-title sec-title-center text-center mb-20">
                        <span className="sub-title mb-15">Built by KOT Enterprises</span>
                        <p className="content">
                          Want something like {product.name} built for your
                          organization? Let's talk.
                        </p>
                      </div>
                      <div className="mt-30">
                        <Link className="thm-btn" to="/#contact">
                          Get in Touch
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ProductShowcase;
